import { useState } from "react";
import { PROJECTS } from "../mock";
import { ArrowUpRight, MapPin, ExternalLink } from "lucide-react";

const CATEGORIES = ["All", "WordPress", "Shopify", "WooCommerce"];

export default function Portfolio() {
  const [filter, setFilter] = useState("All");

  const filtered =
    filter === "All"
      ? PROJECTS
      : PROJECTS.filter((p) =>
          p.category.toLowerCase().includes(filter.toLowerCase())
        );

  return (
    <section id="work" className="py-24 md:py-32 bg-white">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10">
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-6 mb-12 reveal">
          <div>
            <p className="text-xs tracking-[0.25em] uppercase text-neutral-500 mb-4">
              — Selected Work
            </p>
            <h2 data-anim="up" className="display text-[40px] md:text-[64px] leading-[1.02] max-w-2xl">
              Recent{" "}
              <span className="relative inline-block">
                <span className="relative z-10">projects</span>
                <span className="absolute left-0 right-0 bottom-1 h-3 md:h-4 bg-[#FFE14D] -z-0 rounded-sm" />
              </span>{" "}
              <br />I&apos;m proud of.
            </h2>
          </div>

          {/* <div className="flex flex-wrap items-center gap-2">
            {CATEGORIES.map((c) => (
              <button
                key={c}
                onClick={() => setFilter(c)}
                className={`h-10 px-5 rounded-full text-sm font-medium border-2 transition-colors ${
                  filter === c
                    ? "bg-black text-white border-black"
                    : "bg-white text-black border-black/10 hover:border-black"
                }`}
              >
                {c}
              </button>
            ))}
          </div> */}
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
          {filtered.map((p, idx) => (
            <a
              key={p.id}
              href={p.url}
              target="_blank"
              rel="noopener noreferrer"
              className="group relative block rounded-[28px] overflow-hidden reveal border border-black/5 bg-neutral-50"
              style={{ transitionDelay: `${idx * 80}ms` }}
            >
              <div className="p-6 md:p-8 relative">
                <div className="flex items-start justify-between mb-6">
                  <div>
                    <div className="flex items-center gap-3 text-xs uppercase tracking-widest text-neutral-500">
                      <span>{p.year}</span>
                      <span className="w-1 h-1 rounded-full bg-neutral-400" />
                      <span className="flex items-center gap-1">
                        <MapPin size={11} />
                        {p.location}
                      </span>
                    </div>
                    <h3 className="display text-3xl md:text-4xl mt-2">
                      {p.title}
                    </h3>
                    <p className="text-sm text-neutral-600 mt-1">
                      {p.category}
                    </p>
                  </div>
                  <div className="w-11 h-11 rounded-full bg-black text-white flex items-center justify-center group-hover:rotate-45 transition-transform duration-500">
                    <ArrowUpRight size={18} />
                  </div>
                </div>

                <div className="relative rounded-2xl overflow-hidden aspect-[4/2] bg-neutral-200">
                  <img
                    src={p.image}
                    alt={p.title}
                    loading="lazy"
                    className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-[900ms] ease-out"
                    onError={(e) => {
                      e.target.src = `https://api.microlink.io/?url=${encodeURIComponent(
                        p.url
                      )}&screenshot=true&meta=false&embed=screenshot.url`;
                    }}
                  />
                  <div className="absolute bottom-3 right-3 opacity-0 group-hover:opacity-100 transition-opacity">
                    <span className="inline-flex items-center gap-1 bg-white/95 backdrop-blur px-3 py-1.5 rounded-full text-xs font-semibold">
                      <ExternalLink size={12} /> Visit site
                    </span>
                  </div>
                </div>
              </div>
            </a>
          ))}
        </div>

        <div className="flex justify-center mt-12 reveal">
          <a
            href="#contact"
            className="h-12 pl-6 pr-2 rounded-full bg-black text-white text-sm font-semibold hover:bg-neutral-800 transition-colors flex items-center gap-2 group"
          >
            Have a project in mind?
            <span className="w-9 h-9 rounded-full bg-[#FFE14D] text-black flex items-center justify-center group-hover:translate-x-0.5 transition-transform">
              <ArrowUpRight size={16} />
            </span>
          </a>
        </div>
      </div>
    </section>
  );
}
